import { Directive, inject, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { AuthService } from '../../core/auth/auth.service';

// Permissions that only admins can access regardless of user grants
const ADMIN_ONLY_PERMISSIONS = new Set([
  'accounts.view_all', 'accounts.create', 'accounts.edit', 'accounts.delete',
  'users.view', 'users.create', 'users.edit', 'users.deactivate',
  'roles.assign', 'access_requests.review', 'audit_logs.view',
]);

// Permissions that require an explicit user grant (not given to all standard users)
const EXPLICIT_GRANT_PERMISSIONS = new Set([
  'projects.create',
]);

@Directive({ selector: '[hasPermission]', standalone: true })
export class HasPermissionDirective implements OnInit {
  @Input('hasPermission') permission = '';

  private readonly auth = inject(AuthService);
  private readonly tpl = inject(TemplateRef);
  private readonly vcr = inject(ViewContainerRef);

  ngOnInit(): void {
    const user = this.auth.currentUser();
    if (!user) { this.vcr.clear(); return; }

    let show: boolean;
    if (user.role === 'admin') {
      show = true;
    } else if (ADMIN_ONLY_PERMISSIONS.has(this.permission)) {
      show = false;
    } else if (EXPLICIT_GRANT_PERMISSIONS.has(this.permission)) {
      show = (user.permissions ?? []).includes(this.permission);
    } else {
      show = true;
    }

    if (show) this.vcr.createEmbeddedView(this.tpl);
    else this.vcr.clear();
  }
}
